<div *ngIf="vendor">
  <div mat-dialog-title>
    <div *ngIf="vendor.vendor_ID">
      <div i18n>Edit Vendor</div>
    </div>
    <div *ngIf="!vendor.vendor_ID">
      <div i18n>Add Vendor</div>
    </div>
  </div>
  <div>
    <div class="form-inline mb-2">
      <span *ngIf="vendor.vendor_ID" i18n>Make the necessary changes on the form below then click Submit</span>
      <span *ngIf="!vendor.vendor_ID" i18n>To add a new vendor, complete the form below then click Submit.</span>
      <span class="float-right warning col-sm-4" i18n>* Required Information</span>
    </div>
    <form #form="ngForm" (ngSubmit)="saveVendor(form)">
      <div class="form-inline form-group">
        <div class="form-group col-sm-12 col-md-6">
          <label class="col-sm-4" for="vendorType_ID">
            <span class="warning">* </span><span i18n>Vendor Type</span>
          </label>
          <div>
            <select [(ngModel)]="vendor.vendorType_ID" name="vendorType_ID" id="vendorTypeId"
                    class="form-control select-bidit" required #vendortype="ngModel">
              <option [ngValue]="undefined" selected="">-</option>
              <option *ngFor="let type of vendorTypes" [(ngValue)]="type.vendorType_ID">{{type.vendorType_Desc}}</option>
            </select>
            <div [hidden]="!form.submitted || vendortype.valid"
                 class="alert alert-danger" i18n>Vendor Type is invalid</div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="col-sm-4" for="businessName">
            <span class="warning">* </span><span i18n>Business Name</span>
          </label>
          <div>
            <input id="businessName" name="businessName" class="form-control col" [(ngModel)]="vendor.vendor_BusinessName"
                   required #businessName="ngModel"
                   [class.field-error]="form.submitted && businessName.invalid">
            <div [hidden]="!form.submitted || businessName.valid"
                 class="alert alert-danger" i18n>Business name is invalid</div>
          </div>
        </div>
      </div>
      <div class="form-inline form-group">
        <div class="form-group col-md-6">
          <label class="col-sm-4" for="name">
            <span class="warning">* </span><span i18n>First Name</span>
          </label>
          <div>
            <input id="firstName" name="firstName" class="form-control col" [(ngModel)]="vendor.vendor_FirstName"
                   required #firstName="ngModel"
                   [class.field-error]="form.submitted && firstName.invalid">
            <div [hidden]="!form.submitted || firstName.valid"
                 class="alert alert-danger" i18n>Vendor first name is required</div>
          </div>
        </div>
        <div class="form-group  col-sm-12 col-md-6">
          <label class="col-sm-4" for="lastName">
            <span class="warning">* </span><span i18n>Last Name</span>
          </label>
          <div>
            <input id="lastName" name="lastName" class="form-control col" [(ngModel)]="vendor.vendor_LastName"
                   required #lastName="ngModel"
                   [class.field-error]="form.submitted && lastName.invalid">
            <div [hidden]="!form.submitted || lastName.valid"
                 class="alert alert-danger" i18n>Vendor last name is required</div>
          </div>
        </div>
      </div>
      <div class="form-inline form-group">
        <div class="form-group col-md-6">
          <label class="col-sm-4" for="address1">
            <span class="warning">* </span><span i18n>Address 1</span>
          </label>
          <div>
            <input id="address1" name="address1" class="form-control col" [(ngModel)]="vendor.vendor_Address1"
                   required #address1="ngModel"
                   [class.field-error]="form.submitted && address1.invalid">
            <div [hidden]="!form.submitted || address1.valid"
                 class="alert alert-danger" i18n>Address Line 1 is invalid</div>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label class="col-sm-4" for="address2" i18n>Address 2</label>
          <div>
            <input id="address2" name="address2" class="form-control col" [(ngModel)]="vendor.vendor_Address2"
                   #address2="ngModel"
                   [class.field-error]="form.submitted && address2.invalid">
            <div [hidden]="!form.submitted || address2.valid"
                 class="alert alert-danger" i18n>Address Line 2 is invalid</div>
          </div>
        </div>
      </div>

      <div class="form-inline form-group">
        <div class="form-group col-md-4">
          <label class="col-sm-4 col-md-3" for="city">
            <span class="warning">* </span><span i18n>City</span>
          </label>
          <div>
            <input id="city" name="city"
                   required
                   placeholder="City"
                   i18n-placeholder
                   class="form-control col-sm-8 col-md-9"
                   [(ngModel)]="vendor.vendor_City"
                   #city="ngModel"
                   [class.field-error]="form.submitted && city.invalid">
            <div [hidden]="!form.submitted || city.valid"
                 class="alert alert-danger" i18n>City is invalid</div>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label class="col-sm-4 col-md-3" for="state">
            <span class="warning">* </span><span i18n>State</span>
          </label>
          <div>
            <select [(ngModel)]="vendor.vendor_State" name="state" id="state" class="form-control select-bidit" required #state="ngModel"
                    [class.field-error]="form.submitted && state.invalid">
              <option value="" selected="">-</option>
              <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
            </select>
            <div [hidden]="!form.submitted || state.valid"
                 class="alert alert-danger" i18n>State is invalid</div>
          </div>
        </div>

        <div class="form-group col-md-4">
          <label class="col-sm-4 col-md-3" for="postal">
            <span class="warning">* </span><span i18n>Zip</span>
          </label>
          <div>
            <input id="postal" name="postal"
                   required
                   placeholder="zip"
                   class="form-control col-sm-8 col-md-9"
                   [(ngModel)]="vendor.vendor_Postal"
                   #postal="ngModel" />
            <div [hidden]="!form.submitted || postal.valid"
                 class="alert alert-danger" i18n>Enter a valid zip</div>
          </div>
        </div>
      </div>
      <div class="form-inline form-group">
        <div class="form-group col-md-6">
          <label class="col-sm-4" for="phoneNumber" i18n>Phone</label>
          <div>
            <input id="phoneNumber" name="phoneNumber" type="tel"
                   placeholder="(999) 999-9999"
                   appPhoneMask
                   class="form-control col"
                   [(ngModel)]="vendor.vendor_Phone"
                   #phoneNumber="ngModel" />
            <div [hidden]="!form.submitted || phoneNumber.valid"
                 class="alert alert-danger" i18n>Enter a valid email</div>
          </div>
        </div>
        <div class="form-group  col-md-6">
          <label class="col-sm-4" for="mobileNumber" i18n>Cell #</label>
          <div>
            <input id="mobileNumber" name="mobile" type="tel"
                   placeholder="(999) 999-9999"
                   appPhoneMask
                   class="form-control col"
                   [(ngModel)]="vendor.vendor_Mobile"
                   #mobileNumber="ngModel" />
            <div [hidden]="!form.submitted || mobileNumber.valid"
                 class="alert alert-danger" i18n>Enter a valid cell #</div>
          </div>
        </div>
      </div>
      <div class="form-inline">
        <div class="form-group col-md-6">
          <label class=" col-sm-4" for="email" i18n>Email</label>
          <div>
            <input id="email" name="email" type="email"
                   placeholder="email"
                   class="form-control col"
                   [(ngModel)]="vendor.vendor_Email"
                   #email="ngModel" />
            <div [hidden]="!form.submitted || email.valid"
                 class="alert alert-danger" i18n>Enter a valid email</div>
          </div>
        </div>
      </div>
      <mat-dialog-actions align="end">
        <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
        <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
      </mat-dialog-actions>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
      <div class="mt-3">
        <div [hidden]="!form.submitted || form.valid"
             class="alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
      </div>
    </form>
  </div>
</div>

